var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:{
    'header-menu-simplified': true,
    'header-menu-simplified--active': _vm.menuActiveFlag
  }},[_c('div',{class:{
      'header-menu__content': true,
      'header-menu__content--active': _vm.menuActiveFlag
    }},[_c('div',{staticClass:"hamburgermenu-blocks"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }